/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        if((typeof line_item.items) != 'undefined' && $.isArray(line_item.items)){
          callback(line_item.items[line_item.items.length-1], form);
        }else{
          callback(line_item, form);
        }
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, itemAddedCallback;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : '.enj-add-to-cart-btn',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };
    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    //$body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
      if ($cartCountSelector) {
        $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
        $('.mini-cart-counter .enj-cartcount, .minicart-item-count').html(cart.item_count + ' item'); 
        $('.product-popup').find('.product-item-count').html(cart.item_count); 
        $('.js-number-cart').html(cart.item_count);
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.js-number-cart').removeClass('active');
      }
    }
    if ($cartCostSelector) {
      if (cart.total_discount > 0) {
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat) + "<i>Savings: " + Shopify.formatMoney(cart.total_discount, settings.moneyFormat) + "</i>");
      } else {
        $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
      }
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass('is-added').addClass('is-adding');
      $addToCart_btn.find("i").replaceWith('<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    let isGoCheckoutView = $(form).find('.viewCheckOut'); // 直接跳转checkout页面
    $addToCart_btn.removeClass('is-adding').addClass('is-added');
    $addToCart_btn.find('.enj-loader-add-to-cart').html('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" height="400" width="400" xml:space="preserve" id="svg22" version="1.1"><defs id="defs6101"/><g transform="matrix(1.3333333,0,0,-1.3333333,0,400)" id="g10"><g transform="scale(0.1)" id="g12"><path id="path14" style="/* fill:#231f20; */fill-opacity:1;fill-rule:nonzero;stroke:none;" d="M 2539.18,1385.02 C 2479.15,849.23 2004.9,434.289 1446.39,470.129 931.406,503.16 516.711,917.871 483.672,1432.85 c -38.359,597.88 439.844,1099.19 1029.878,1099.19 78.39,0 149.09,-7.24 218.27,-21.98 42.37,-9.03 86.4,4.1 116.99,34.78 v 0 c 71.82,72.04 34.9,194.92 -64.67,215.74 -88.86,18.58 -179.73,29.87 -270.59,29.87 -709.417,0 -1290.445,-581.02 -1290.445,-1290.45 0,-709.418 581.028,-1290.449 1290.445,-1290.449 661.24,0 1210.92,504.781 1282.54,1147.799 8.47,76.02 -50.73,142.65 -127.21,142.65 h -2.45 c -65.64,0 -119.94,-49.75 -127.25,-114.98 z M 894.004,1654.48 v 0 c -49.668,-49.89 -49.578,-130.58 0.207,-180.36 L 1384.35,983.98 2584.51,2184.15 c 49.87,49.87 49.87,130.71 0,180.57 l -0.23,0.23 c -49.88,49.87 -130.74,49.85 -180.6,-0.03 L 1384.35,1344.99 1074.79,1654.67 c -49.94,49.95 -130.95,49.87 -180.786,-0.19"/></g></g></svg>');

    $('.product-popup').find('.product-name').html(product.title);  
    $('.product-popup').find('.product-price').html(Shopify.formatMoney(product.price, settings.moneyFormat)); 
    $('.product-popup').find('.product-qty').html(product.quantity); 
    $('.product-popup').find('.product-total').html(Shopify.formatMoney(product.line_price, settings.moneyFormat)); 


    $('.product-popup').find('.product-image img').attr('src', product.image);

    //showPopup('.product-popup');
     if (isGoCheckoutView && isGoCheckoutView.length > 0) {
        $('.js-minicart').removeClass('active');
        $('.bg-minicart').removeClass('active');
     } else {
        $('.js-minicart').addClass('active');
        $('.bg-minicart').addClass('active');
      }
    // google code
    // gtag('event', 'conversion', {'send_to': 'AW-11395279778/y_dxCJ69rPwYEKLX2Lkq'});
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku,
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku+'_1tit',
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku+'_2tit',
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku+'_3tit',
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku+'_4tit',
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    // gtag('event','add_to_cart', {
    //   'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items': [
    //     {
    //       'id': product.sku+'_5tit',
    //       'google_business_vertical': 'retail'
    //     }]
    // });
    //   gtag('event','add_to_cart', {
    //     'value': Shopify.formatMoney(product.price, "\{\{amount\}\}"),
    //   'items':[{
    //     'id':product.sku,
    //     'google_business_vertical': 'custom',
    //   }]
    // });
    pintrk(
        'track',
        'AddToCart',
        {
          value: Shopify.formatMoney(product.price, "\{\{amount\}\}"),
          order_quantity: product.quantity,
          currency: 'USD'
        }
    );
    window.uetq = window.uetq || [];
    window.uetq.push('event', 'add_to_cart', {});
    const isTrue = isGoCheckoutView && isGoCheckoutView.length > 0 ? true : false
    ShopifyAPI.getCart(cartUpdateCallback);
    if (isGoCheckoutView && isGoCheckoutView.length > 0) { // 跳转checkout页面
      setTimeout(function() {
          $('a.button-checkout').length > 0 && $('a.button-checkout')[0].click();
      }, 1000)
    }
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');
    $addToCart.find('.enj-loader-add-to-cart').remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $('#digger_price_cart_block').html('');
      $cartContainer
      .append('<div class="list_product_minicart empty"><div class="empty-product_minicart"><p class="mb-0">Your cart is currently empty.</p><a href="/collections/best-selling" class="to-cart">Go Shopping</a></div></div>');
      cartCallback(cart);
      return;
      $('.js-number-cart').removeClass('active');
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    var automaticDiscountCodes = [];
    
    /*---digger 20240112--*/
    var digger_items_subtotal = 0;
    var digger_items_save = 0;
    var digger_items_save_pirce = 0;
    /*---digger 20240112--*/
    var code_list = [];
    if(cart.cart_level_discount_applications.length>0){
      cart.cart_level_discount_applications.forEach(i => {
        if((typeof i.discount_application) != 'undefined'){
          code_list.push(i.discount_application.title.toUpperCase());
        }else if((typeof i.title) != 'undefined'){
          code_list.push(i.title.toUpperCase());
        }
      });
    }else if(cart.discount_codes.length>0){
      cart.discount_codes.forEach(i => {
        if(i.applicable == true){
          if((typeof i.code) != 'undefined'){
            code_list.push(i.code.toUpperCase());
          }else if((typeof i.title) != 'undefined'){
            code_list.push(i.title.toUpperCase());
          }
        }
      });
    }
    code_list.forEach(code_item=>{
      var automaticDiscountCode = {
        automaticDiscountCode:code_item
      };
      automaticDiscountCodes.push(automaticDiscountCode);
    });
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      /*---digger 20240112--*/
      try{
          if((typeof cartItem.variant_id) == 'undefined' || cartItem.variant_id == null){
            var digger_variant_id = cartItem.product_id;
          }else{
            var digger_variant_id = cartItem.id;
          }
          var digger_cart_item = null;
          if($('#digger_price_cart_block #digger_price_'+digger_variant_id).length >0){
            digger_cart_item = $('#digger_price_cart_block #digger_price_'+digger_variant_id);
          }else if($('#digger_price_cart_block #digger_price_'+cartItem.product_id).length >0){
            digger_cart_item = $('#digger_price_cart_block #digger_price_'+cartItem.product_id);
          }else if($('.content-page-detail #digger_price_'+cartItem.product_id).length >0){
            var digger_goods_item = $('.content-page-detail #digger_price_'+cartItem.product_id);
          }
          var cart_item_compare_at_price = 0;
          var cart_item_save_price = 0;
          var cart_item_save_price_format = '';
          if(digger_cart_item != null) {
            cart_item_compare_at_price = parseInt($.trim(digger_cart_item.attr('compare_at_price')));
            cart_item_save_price = parseInt($.trim(digger_cart_item.attr('save_price')));
            digger_items_subtotal = digger_items_subtotal + cart_item_compare_at_price * cartItem.quantity;
            digger_items_save = digger_items_save + cart_item_save_price * cartItem.quantity;
            cart_item_save_price_format = digger_cart_item.attr('save_off');
          }else if(digger_goods_item != null) {
            cart_item_compare_at_price = parseInt($.trim(digger_goods_item.attr('compare_at_price')));
            var cart_item_price = parseInt($.trim(digger_goods_item.attr('price')));
            cart_item_save_price = parseInt($.trim(digger_goods_item.attr('save_price')));
            if(cart_item_compare_at_price == 0){
              var digger_goods_item_compare_at_price = cart_item_price;
              digger_items_subtotal = digger_items_subtotal + cart_item_price * cartItem.quantity;
            }else{
              var digger_goods_item_compare_at_price = cart_item_compare_at_price;
              digger_items_subtotal = digger_items_subtotal + cart_item_compare_at_price * cartItem.quantity;
            }
            digger_items_save = digger_items_save + cart_item_save_price * cartItem.quantity;
            cart_item_save_price_format = digger_goods_item.attr('save_off');
            var cart_item_input_html = '<input type="hidden" compare_at_price="'+digger_goods_item_compare_at_price+'" ';
            cart_item_input_html += 'save_price="'+cart_item_save_price+'" compare_at_prices="'+(digger_goods_item_compare_at_price * cartItem.quantity)+'" ';
            cart_item_input_html += 'save_prices="'+(cart_item_save_price * cartItem.quantity)+'" ';
            cart_item_input_html += 'save_off="'+cart_item_save_price_format+'" id="digger_price_'+digger_variant_id+'" class="digger_price_cart_list">';
            $('#digger_price_cart_block').append(cart_item_input_html);
          }
          var cart_item_compare_at_price_format = '';
          if(cart_item_compare_at_price > 0 && cart_item_compare_at_price > cartItem.price){
            cart_item_compare_at_price_format = Shopify.formatMoney(cart_item_compare_at_price, settings.moneyFormat);
          }
      } catch (e) {
          console.log(e);
      }
      /*---digger 20240112--*/
      /*
      if(cartItem.discounts.length > 0){
        automaticDiscountCode = cartItem.discounts[0].title;
      }*/
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        cart_item_compare_at_price: cart_item_compare_at_price_format,
        cart_item_save_price: cart_item_save_price_format
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    var originTotalPrice = "";
    var TotalDiscount = "";
    var discountCode = "";
    var cart_items_original_off = "";
    var total_have_no_saving = "total-have-no-saving";
    if (cart.total_price != cart.original_total_price) {
      originTotalPrice = Shopify.formatMoney(cart.original_total_price, settings.moneyFormat);
    }
    try{
        if (cart.total_discount > 0 || digger_items_save > 0) {
          total_have_no_saving = "";
          TotalDiscount = Shopify.formatMoney((cart.total_discount+digger_items_save), settings.moneyFormat);
        }
        if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          discountCode = cart.cart_level_discount_applications[0].title;
        }
        var digger_items_subtotal_format = 0;
        var digger_items_save_format = 0;
        if (digger_items_subtotal > 0) {
          digger_items_subtotal_format = Shopify.formatMoney(digger_items_subtotal, settings.moneyFormat);
        }
        if (digger_items_save > 0) {
          cart_items_original_off = "cart-items-original-off";
          digger_items_save_format = Shopify.formatMoney(digger_items_save, settings.moneyFormat);
        }
    } catch (e) {
      console.log(e);
    }
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      originTotalPrice: originTotalPrice,
      TotalDiscount: TotalDiscount,
      discountCode: discountCode,
      automaticDiscountCodes : automaticDiscountCodes,
      cart_items_original_off:cart_items_original_off,
      total_have_no_saving:total_have_no_saving,
      digger_items_subtotal:digger_items_subtotal_format,
      digger_items_save_pirce:digger_items_save,
      digger_items_save:digger_items_save_format
    }
    $('.product-popup').find('.product-total-cart').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    $cartContainer.append(template(data));

    cartCallback(cart);
    $('.js-number-cart').addClass('active');
    if (digger_items_save > 0) {
      $('.digger-cart-items-save-price, .digger-cart-items-final-price').removeClass('hide');
    }else{
       $('.digger-cart-items-save-price, .digger-cart-items-final-price').addClass('hide');
    }
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);

    if (cart.total_discount > 0) {
        $(".enj-minicart-ajax .total-info-order .cart-items-subtotal").html(Shopify.formatMoney(cart.original_total_price, settings.moneyFormat));
        $(".enj-minicart-ajax .total-info-order .cart-items-discount").html("-" + Shopify.formatMoney(cart.total_discount, settings.moneyFormat));
        $(".enj-minicart-ajax .prod").removeClass("noDiscount");
      } else {
        $(".enj-minicart-ajax .total-info-subtotal .cart-items-subtotal").html(Shopify.formatMoney(cart.original_total_price, settings.moneyFormat));
        $(".enj-minicart-ajax .total-info-order .cart-items-subtotal").html("");
        $(".enj-minicart-ajax .total-info-order .cart-items-discount").html("");
        $(".enj-minicart-ajax .prod").addClass("noDiscount");
      }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart
    $body.on('change', '.minicart_item .ajaxcart__qty-num', function() {
      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));
      if (qty > 0) {
        updateQuantity(line, qty);
      }
    });

    var _debounce = function (delay) {
        let timer = null
        return function (fn) {
            if (timer) clearTimeout(timer)
            timer = setTimeout(fn, delay)
        }
    }
    var __debounce = _debounce(300)
    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this)
      var line = $el.data('line'),
            $qtySelector = $el.siblings('.ajaxcart__qty-num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      qty = validateQty(qty);  
      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty)
      __debounce(function () {
          // If it has a data-line, update the cart.
          // Otherwise, just update the input's number
          if (line) {
            updateQuantity(line, qty);
          } else {
            $qtySelector.val(qty);
          }
      }.bind(this))

    });

    $body.on('click', '.remove-product', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = 0
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    })

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.parent('.qty-cart-content').empty().append(template(data))
        //$el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
          console.log(qty);
          updatePricingQty(qty);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    itemAddedCallback: itemAddedCallback
  };
  return module;
}(ajaxCart || {}, jQuery));


